import React, {useMemo} from 'react';
import type {EBirdMyDataSchema} from "ebird-mydata-reader";
import {
    MONTHLY_SIGHTINGS_EMPTY_LABEL,
    MONTHLY_SIGHTINGS_HELPER,
    MONTHLY_SIGHTINGS_TITLE
} from "./constants";
import {getMonthlySightingsChartData} from "./helpers";
import './monthly-sightings-chart.scss';

export type MonthlySightingsChartProps = {
    observations: EBirdMyDataSchema[]
}

export function MonthlySightingsChart({observations}: MonthlySightingsChartProps) {
    const chartData = useMemo(() => {
        return getMonthlySightingsChartData(observations);
    }, [observations]);

    const peakLabel = chartData.peakMonthsLabel || MONTHLY_SIGHTINGS_EMPTY_LABEL;
    const helperLabel = chartData.peakCount > 0
        ? `${chartData.peakCount.toLocaleString()} observation${chartData.peakCount === 1 ? '' : 's'}`
        : MONTHLY_SIGHTINGS_HELPER;

    return (
        <section className="checklist__monthly-sightings" aria-label="Monthly sighting summary">
            <div className="checklist__monthly-sightings-header">
                <h3>{MONTHLY_SIGHTINGS_TITLE}</h3>
                <strong>{peakLabel}</strong>
                <p>{helperLabel}</p>
            </div>

            <div className="checklist__monthly-sightings-chart" role="img" aria-label={`Monthly sightings chart. Peak months: ${peakLabel}.`}>
                {chartData.months.map(month => (
                    <div
                        key={month.month}
                        className={`checklist__monthly-sightings-month ${month.isPeak ? 'is-peak' : ''}`}
                    >
                        <div className="checklist__monthly-sightings-bar-track">
                            {month.hasSightings ?
                                <div
                                    className="checklist__monthly-sightings-bar"
                                    style={{
                                        height: `${month.heightPercent}%`
                                    }}
                                    title={`${month.label}: ${month.count}`}
                                    aria-label={`${month.label}: ${month.count} sighting${month.count === 1 ? '' : 's'}`}
                                />
                                : null
                            }
                        </div>
                        <span className="checklist__monthly-sightings-label">{month.label.charAt(0)}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
